import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import styled from "styled-components";

import ViewFooter from "../views/ViewFooter";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";
import ViewGerenciarEtiquetaPessoa from "../views/ViewGerenciarEtiquetaPessoa";

const ContainerComponente = styled.div`
  width: 100%;
  min-height: 100vh; /* Garante que ocupa 100% da altura da viewport */
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f4f7;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;
const GerenciarEtiquetaPessoa: React.FC = () => {
  const { isLoading, isValid } = usePermissao("OPE");
  // ⏳ Enquanto verifica permissão
  if (isLoading) {
    return (
      <p style={{ textAlign: "center", marginTop: "2rem" }}>
        Verificando permissão...
      </p>
    );
  }

  // 🚫 Se não tiver permissão
  if (!isValid) {
    return null;
  }
  return (
    <ContainerComponente>
      <ViewAppBar />
      <ViewGerenciarEtiquetaPessoa />
      <ViewFooter />
    </ContainerComponente>
  );
};

export default GerenciarEtiquetaPessoa;
